import React from 'react';

import { InputComponent } from 'site-modules/lease-deals/components/input/input';

export const ZipPresentationComponent = props => {
  return (
    <InputComponent
      {...props}
      startAdornment={<i className="icon-location5 size-14 text-cool-gray-40 me-0_25" aria-hidden />}
      labelText="Zip Code"
    />
  );
};
